const forms = [
    {
        name: "Booking",
        options: [
            {
                name: "Customer",
                type: "selectandadd",
                path: "/app/customers/add",
                form: {
                    name: "customer",
                    allowClear: true,
                    showSearch: true,
                    filterOption: false,
                    placeholder: "Customer",
                    api: "get-all-customers",
                    options: null,
                    value: null,
                    required: true,
                },
            },
            {
                name: "Number",
                type: "input",
                form: {
                    type: "text",
                    name: "number",
                    placeholder: "Booking number",
                    value: "",
                    required: false,
                },
            },
            {
                name: "Date",
                type: "date",
                form: {
                    name: "date",
                    placeholder: "Booking date",
                    value: "",
                    required: true,
                },
            },
            {
                name: "Valid Until",
                type: "date",
                form: {
                    name: "expiry_date",
                    placeholder: "Valid until",
                    value: "",
                    required: false,
                },
            },
            {
                name: "Salesman",
                type: "selectandadd",
                path: "/app/salesman/add",
                form: {
                    name: "salesman",
                    allowClear: true,
                    showSearch: true,
                    filterOption: false,
                    placeholder: "Salesman",
                    api: "get-all-salesman",
                    options: null,
                    value: null,
                    required: false,
                },
            },
            {
                name: "Status",
                type: "select",
                form: {
                    name: "status",
                    allowClear: false,
                    placeholder: "Status",
                    value: 0,
                    options: [
                        { value: 0, label: "Pending" },
                        { value: 1, label: "Confirmed" },
                    ],
                    required: false,
                },
            },
        ],
    },

];

export default forms;